import { render, staticRenderFns } from "./SAvatarStemdoer.vue?vue&type=template&id=8d3312fa&scoped=true"
import script from "./sAvatarStemdoer.ts?vue&type=script&lang=ts&external"
export * from "./sAvatarStemdoer.ts?vue&type=script&lang=ts&external"
import style0 from "./SAvatarStemdoer.vue?vue&type=style&index=0&id=8d3312fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3312fa",
  null
  
)

export default component.exports